// -----------------------------------------------------------------------
// <copyright file='getHelpEcsData.ts' company='Microsoft'>
//     copyright (c) Microsoft. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

export interface GetHelpEcsData {
  flightList: string[];
  configIds: string[];
  eTag: string;
}

export const initialGetHelpEcsStateData: GetHelpEcsData = {
  flightList: [],
  configIds: [],
  eTag: '',
};
